class FoundationProjects {
  constructor(element, _settings = {}) {
    if (!element) { return; }

    this.props = {
      element,
      settings: {
        closeOther: true,
        handleSelector: '.js-foundation-projects__handle',
        panelSelector: '.js-foundation-projects__panel',
        featuredPanelSelector: '.js-foundation-projects__panel--featured',
        closeButtonSelector: '.js-foundation-projects__close',
        ..._settings,
      },
    }

    this.initHandles();
    this.initCloseButtons();
  }

  initHandles() {
    const handles = this.props.element.querySelectorAll(this.props.settings.handleSelector);

    if (handles.length === 0) return;

    handles.forEach(handle => {
      this.initHandle(handle);
    });
  }

  initCloseButtons() {
    const buttons = this.props.element.querySelectorAll(this.props.settings.closeButtonSelector);
    const featuredPanel = this.props.element.querySelector(this.props.settings.featuredPanelSelector);

    if (buttons.length === 0) return;

    buttons.forEach(button => {
      button.addEventListener('click', event => {
        event.preventDefault();
        this.closeAll();
        if (featuredPanel) {
          featuredPanel.classList.add('is-open');
        }
      });
    });
  }

  initHandle(element) {
    const panelId = element.dataset.panelId;
    const targetPanel = this.props.element.querySelector(`#${panelId}`);
    const featuredPanel = this.props.element.querySelector(this.props.settings.featuredPanelSelector);

    if (!targetPanel) return;

    element.addEventListener('click', event => {
      event.preventDefault();

      if (!element.classList.contains('is-open')) {
        if (this.props.settings.closeOther) {
          this.closeAll();
        }
        targetPanel.classList.add('is-open');

        element.classList.add('is-open');
      } else {
        if (this.props.settings.closeOther) {
          this.closeAll();
        }
        if (featuredPanel) {
          featuredPanel.classList.add('is-open');
        }
      }

      document.body.classList.add('lock-header');
      this.props.element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.props.element.scrollTop = 0;
      setTimeout(() => {
        this.hideFoundationHeader();
        document.body.classList.remove('lock-header');
      }, 1000);
    });
  }

  closeAll() {
    const panels = this.props.element.querySelectorAll(this.props.settings.panelSelector);
    const handles = this.props.element.querySelectorAll(this.props.settings.handleSelector);

    if (panels.length !== 0) {
      panels.forEach(panel => {
        panel.classList.remove('is-open');
      });
    }

    if (handles.length !== 0) {
      handles.forEach(handle => {
        handle.classList.remove('is-open');
      });
    }
  }

  hideFoundationHeader() {
    const foundationHeader = document.querySelector('.js-foundation-header');

    if (!foundationHeader) return;
    foundationHeader.classList.remove('is-scrolled-up');
    foundationHeader.classList.add('is-scrolled-down');
  }
}

const initFoundationProjects = async () => {
  window.addEventListener("DOMContentLoaded", () => {
    const element = document.querySelector('.js-foundation-projects');
    if (!element) return;

    new FoundationProjects(element);
  });
}
initFoundationProjects();